import { cn } from 'components/UI/cn'
import { Tooltip } from 'components/Tooltip/tooltip'

/** Shared green outlined pill style used by deal and category badges. */
export const CATEGORY_BADGE_CLASS =
  'inline-flex items-center flex-shrink-0 whitespace-nowrap px-1 py-0.5 text-xs font-medium text-brand bg-surface-muted border border-brand rounded leading-[14.4px] tracking-[0.09px]'

interface DealBadgeProps {
  dealIdentifier: string
  dealName?: string | null
  onClick?: () => void
}

/** Green outlined pill showing "Deal #XXXXX" with optional tooltip for deal name. */
export function DealBadge({
  dealIdentifier,
  dealName,
  onClick,
}: DealBadgeProps) {
  const badge = (
    <span
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick}
      onKeyDown={
        onClick
          ? (e) => (e.key === 'Enter' || e.key === ' ') && onClick()
          : undefined
      }
      className={cn(
        CATEGORY_BADGE_CLASS,
        onClick && 'cursor-pointer hover:bg-surface-hover'
      )}
    >
      Deal #{dealIdentifier}
    </span>
  )

  if (dealName) {
    return <Tooltip content={dealName}>{badge}</Tooltip>
  }

  return badge
}
